<template>
  <base-section id="products-detail">
    <v-container class="mt-n16">
      <v-row>
        <v-col cols="12" md="12">
          <template>
            <v-card
              class="mx-auto"
              v-for="data in posts"
              :key="data.web_product_id"
              flat
            >
              <v-row justify="space-between">
                <v-col cols="12" md="12">
                  <v-img
                    :src="data.web_product_src_url"
                    max-height="300"
                    max-width="100%"
                    :alt="$route.params.url"
                  ></v-img>
                  <v-row no-gutters>
                    <v-col v-for="data in benefits" :key="data.title">
                      <v-card outlined>
                        <v-card-actions>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon large color="primary">{{
                                data.icon
                              }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>{{
                                data.title
                              }}</v-list-item-title>
                              <v-list-item-subtitle>{{
                                data.subtitle
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <div class="headline my-5 primary--text">{{ title }}</div>
                  <!-- <div class="body-2 accent--text">
                    {{ FormatDateFullOnlyDate(data.web_product_cdate) }}
                  </div> -->
                  <small>Bagikan : </small>
                  <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="sharing.url"
                    :title="sharing.title"
                    :hashtags="sharing.hashtags"
                  >
                    <v-icon :color="network.color">{{ network.icon }}</v-icon>
                  </ShareNetwork>
                  <v-alert
                    border="top"
                    colored-border
                    color="primary"
                    class="grey lighten-4 body-2 text-justify"
                  >
                    <div itemscope v-html="data.web_product_detail"></div>
                    <v-btn
                      v-if="data.web_product_file_url"
                      class="mt-4"
                      color="primary"
                      :href="data.web_product_file_url"
                      target="_blank"
                      download
                      small
                    >
                      Download RIPLAY
                    </v-btn>
                    <v-btn
                      v-if="
                        data.web_product_attachment1 &&
                          data.web_product_attachment1_url
                      "
                      class="mt-4 ml-2"
                      color="primary"
                      :href="data.web_product_attachment1_url"
                      target="_blank"
                      download
                      small
                    >
                      Download {{ data.web_product_attachment1 }}
                    </v-btn>
                    <v-btn
                      v-if="
                        data.web_product_attachment2 &&
                          data.web_product_attachment2_url
                      "
                      class="mt-4 ml-2"
                      color="primary"
                      :href="data.web_product_attachment2_url"
                      target="_blank"
                      download
                      small
                    >
                      Download {{ data.web_product_attachment2 }}
                    </v-btn>
                  </v-alert>
                </v-col>
                <!-- <v-col cols="12" md="4">
                  <v-card outlined>
                    <template v-if="posts[0].web_product_cob === '01'">
                      <v-card-title class="body-2 font-weight-bold">
                        Tetap dirumah dan Lindungi Properti Anda
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          label="Kode Pos Aset Properti Anda"
                          single-line
                          class="mx-2"
                          required="required"
                        />
                        <v-btn
                          color="secondary"
                          tile="tile"
                          class="font-weight-bold ml-2 mb-2"
                          block
                        >
                          Hitung Kontribusi
                        </v-btn>
                      </v-card-text>
                    </template>
                    <template v-else-if="posts[0].web_product_cob === '02'">
                      <v-card-title class="body-2 font-weight-bold">
                        Tetap dirumah dan Lindungi kendaraan anda
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          id="vehicle_reg"
                          label="Plat Nomor Kendaraan Anda"
                          single-line
                          class="mx-2"
                          prepend-inner-icon="mdi-view-list"
                          @click:prepend-inner="RegisterVeh"
                          :prefix="prefix"
                          required="required"
                        />
                        <div class="ml-2 body-2 primary--text">
                          * Untuk mengganti plat nomor klik icon
                          <v-icon @click="RegisterVeh">mdi-view-list</v-icon>
                        </div>
                        <v-btn
                          color="fourth"
                          tile="tile"
                          class="font-weight-bold ml-2 mb-2"
                          block
                        >
                          Hitung Kontribusi
                        </v-btn>
                      </v-card-text>
                    </template>
                    <template v-if="posts[0].web_product_cob === '11'">
                      <v-card-title class="body-2 font-weight-bold">
                        Lindungi diri anda selama perjalanan mudik
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          label="Beri tahu kami tujuan perjalanan anda"
                          single-line
                          class="mx-2"
                          required="required"
                        />
                        <v-btn
                          color="primary"
                          tile="tile"
                          class="font-weight-bold ml-2 mb-2"
                          block
                        >
                          Cek Disini
                        </v-btn>
                      </v-card-text>
                    </template>
                    <template v-else>
                      <v-card-text>
                        <span class="body-2"
                          >Hubungi Customer Solution kami untuk detail produk
                          ini melalui Whatsapp</span
                        >
                        <div>
                          <v-btn
                            color="secondary"
                            outlined
                            block
                            large
                            class="title"
                            @click="Whatsapp"
                            ><v-icon>mdi-whatsapp</v-icon>0811 1906 1995</v-btn
                          >
                        </div>

                        <div class="mt-2 mb-4">F.A.Q</div>

                        <v-row justify="center">
                          <v-expansion-panels accordion focusable>
                            <v-expansion-panel
                              v-for="data in faq"
                              :key="data.faq_id"
                            >
                              <v-expansion-panel-header
                                >Q:
                                {{
                                  data.faq_question
                                }}</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                A: {{ data.faq_answer }}
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-row>
                      </v-card-text>
                    </template>
                  </v-card>
                </v-col> -->
              </v-row>
              <v-card-actions> </v-card-actions>
            </v-card>
          </template>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="bottom_sheet">
      <v-list class="pt-0">
        <v-subheader class="primary white--text" @click="bottom_sheet = false"
          >Plat Nomor <v-spacer></v-spacer
          ><span class="cursor">tutup</span></v-subheader
        >
        <v-progress-linear
          :indeterminate="true"
          v-if="loading"
        ></v-progress-linear>
        <div class="scrollable">
          <v-list-item
            v-for="platnomor in platnomors"
            :key="platnomor.gendtab_id"
            @click="GetRegisterVeh(platnomor.gendtab_id)"
          >
            <v-list-item-title class="text-center">{{
              platnomor.gendtab_id
            }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-bottom-sheet>
    <v-snackbar v-model="snackbar.value">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="fourth"
          text
          v-bind="attrs"
          @click="snackbar.value = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </base-section>
</template>

<script>
export default {
  name: "SectionProductsDetail",
  data: () => ({
    title: "",
    share: false,
    posts: [],
    benefits: [],
    faq: [],
    sharing: {
      url: "",
      title: "",
      hashtags: "takafulumum,asuransisyariah"
    },
    networks: [
      { network: "email", name: "Email", icon: "mdi-email", color: "primary" },
      {
        network: "facebook",
        name: "Facebook",
        icon: "mdi-facebook",
        color: "primary"
      },
      {
        network: "telegram",
        name: "Telegram",
        icon: "mdi-telegram",
        color: "primary"
      },
      {
        network: "twitter",
        name: "Twitter",
        icon: "mdi-twitter",
        color: "primary"
      },
      {
        network: "whatsapp",
        name: "Whatsapp",
        icon: "mdi-whatsapp",
        color: "primary"
      }
    ],
    prefix: "B",
    bottom_sheet: false,
    platnomors: [],
    snackbar: {
      value: false,
      text: ""
    }
  }),
  beforeRouteLeave(to, from, next) {
    if (this.bottom_sheet) {
      this.bottom_sheet = false;
      next(false);
    } else {
      next();
    }
  },
  created() {
    this.List();
  },
  watch: {
    "$route.params.url"(val) {
      console.log(val);
      this.List();
    },
    title: function(val, old) {
      console.log(old);
      document.title = val;
      this.sharing.title =
        this.$functions.AppURL() + "" + this.$router.currentRoute.path;
    }
  },
  methods: {
    List() {
      this.loading = true;
      let title = this.$route.params.url;
      let formdata = {
        web_product_id: title
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebProductList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.posts = feedback;
              this.title = this.posts[0].web_product_name;
              this.loading = false;
              this.Benefits(this.posts[0].web_product_id);
              this.FAQ(this.posts[0].web_product_id);
            } else {
              this.snackbar.value = true;
              this.snackbar.text = feedback[0].feedback;
            }
          }
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
          this.loading = false;
        });
    },
    Benefits(id) {
      if (id !== "") {
        if (id !== "takaful-suretyship") {
          this.benefits = [
            {
              title: "Non Riba",
              subtitle: "Dengan akad Wakalah dan Tabarru",
              icon: "mdi-food-halal"
            },
            {
              title: "Hemat",
              subtitle: "Dengan rate bawah OJK",
              icon: "mdi-hand-heart"
            },
            {
              title: "OJK",
              subtitle: "Terdaftar dan Diawasi OJK",
              icon: "mdi-shield-check-outline"
            }
          ];
        } else {
          this.benefits = [
            {
              title: "Non Riba",
              subtitle: "Dengan akad KAFALAH",
              icon: "mdi-food-halal"
            },
            {
              title: "OJK",
              subtitle: "Berizin dan diawasi OJK",
              icon: "mdi-shield-check-outline"
            }
          ];
        }
      }
    },
    FAQ(id) {
      let formdata = {
        faq_refno: id
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebFAQList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          let data = response.data;
          if (data.length > 0) {
            if (data[0].feedback === "Y") {
              this.faq = data;
            } else {
              this.snackbar.value = true;
              this.snackbar.text = data[0].feedback;
            }
          } else {
            this.faq = [];
          }
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
        });
    },
    RegisterVeh() {
      this.bottom_sheet = true;
      this.$axios
        .post(
          this.$functions.SafeURL(
            "apiListGenTableSimple",
            `gendtab_actived=Y&gendtab_refid=V08&order_by=gendtab_id&order_type=ASC`
          )
        )
        .then(response => {
          this.platnomors = response.data;
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
        });
    },
    GetRegisterVeh(id) {
      this.prefix = id;
      this.bottom_sheet = false;
      setTimeout(function() {
        document.getElementById("vehicle_reg").focus();
      }, 500);
    },
    FormatDateFullOnlyDate(date) {
      return this.$functions.FormatDateFullOnlyDate(date);
    },
    Whatsapp() {
      window.open(
        "https://api.whatsapp.com/send?phone=6281119061995&text=Assalamualaikum%20wr%20wb%2C%20saya%20ingin%20tahu%20produk%20" +
          this.title
      );
    }
  }
};
</script>
